import { render, staticRenderFns } from "./CountBeds.vue?vue&type=template&id=08435f7a&"
import script from "./CountBeds.vue?vue&type=script&lang=js&"
export * from "./CountBeds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports